<template>
  <div class="distributionDetail">
    <van-notice-bar mode="closeable" v-if="detailData.isAuth === 0">该用户还未实名认证，请谨慎沟通，谨防诈骗</van-notice-bar>
    <div class="bg"></div>
    <div class="bgf">
      <div class="distribution-top distributionBox">
        <div>
          <img class="user-headImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
               v-if="!detailData.headImg">
          <img :src="detailData.headImg" v-else class="user-headImg" @click.stop="imagePreview(detailData.headImg)">
        </div>

        <div class="name">
          {{ detailData.name }}
        </div>

        <div class="tag-div">
          <van-tag v-if="detailData.isAuth === 1" plain class="is-auth-tag" size="medium">
            已实名
          </van-tag>
          <van-tag v-else plain color="#999999" text-color="#999999" size="medium">
            未实名
          </van-tag>
          <van-tag v-if="detailData.type === 1" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
            班组
          </van-tag>
          <van-tag v-else-if="detailData.type === 2" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
            企业
          </van-tag>
          <van-tag v-else plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
            个人
          </van-tag>
          <van-tag v-if="detailData.workAge" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
            {{ detailData.workAge + '年工龄' }}
          </van-tag>
        </div>

<!--        <div class="WRAST" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id === 'score'">
          <span class="text">{{ val.key }}</span>
          <span class="WRASText" v-if="val.value.socreLevel == -1">黑名单</span>
          <span class="WRASText" v-if="val.value.socreLevel == 0">信用未评级</span>
          <van-rate
            v-model="val.value.starCount"
            :size="20"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
          />
        </div>-->
        <div class="phone-div">
          <van-row>
            <van-col span="14" class="phone" style="text-align: left">
              <van-icon name="phone-circle" color="#37A1FFFF"/>
              {{ detailData.mobile }}
            </van-col>
            <van-col span="10" style="text-align: right">
              <img src="../../assets/images/publicImg/btn_phone.png" class="btn_phone"
                   @click.stop="callPhone">
            </van-col>
          </van-row>
        </div>
      </div>

      <div class="basic projectContent distributionBox">
        <div class="title1" v-if="detailData.datas">

          <van-row>
            <van-col span="12" class="title2" style="font-weight: bold;text-align: left">
              求职期望
            </van-col>
            <van-col class="title3" span="12" style="text-align: right; font-weight: 500">
              <van-icon :name="zhaohuo_icon_now"/>
              {{ detailData.type === 2 ? '正在找合作' : '正在找工作' }}
            </van-col>
          </van-row>
          <van-row>
            <van-tag v-for="(val, ind) in detailData.tags" style="margin-right: 5px;margin-top:10px;" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
              {{ val }}
            </van-tag>
          </van-row>
        </div>

        <div class="info-div">
          <div class="info-content" v-if="detailData.type === 2">
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_org.png"/>
            </div>
            <div class="text">企业资质：{{ detailData.infos }}</div>
          </div>
          <div class="info-content" v-else>
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_gongzhong.png"/>
            </div>
            <div class="text">找活工种：{{ detailData.infos }}</div>
          </div>

          <div class="info-content" v-if="detailData.type === 2">
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_chengshi.png"/>
            </div>
            <div class="text">找活城市：{{ detailData.cityInfo }}</div>
          </div>

          <div class="info-content" v-else>
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_chengshi.png"/>
            </div>
            <div class="text">找活城市：{{ detailData.cityInfo }}</div>
          </div>

          <div class="info-content" v-if="detailData.type === 2">
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_lianxiren.png"/>
            </div>
            <div class="text">联系人：{{ detailData.contactName }}</div>
          </div>

          <div class="info-content">
            <div class="icon-div">
              <van-icon
                name="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaohuo_icon_jieshao.png"/>
            </div>
            <div class="text">{{ detailData.content }}</div>
          </div>
        </div>

        <div class="title" v-if="detailData.attachments !== undefined && detailData.attachments.length > 0">图片和视频</div>
        <div class="fileBox">

          <div v-for="(item, index) in detailData.attachments" :key="index"
               @click="attachsDetail(item, index)">
            <div style="position: relative">
              <img :src="item.attachUrl"
                   v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg'">
              <div v-if="item.fileType ==='mp4'" class="videoBox">
                <video :poster="item.attachUrl+'?x-oss-process=video/snapshot,t_1,m_fast'" :src="item.attachUrl"
                       class="video"></video>
                <img src="../../assets/images/publicImg/icon_video_bg.png" class="icon_video_bg">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl" :phoneNumber="detailData.mobile"/>
    <actionBar ref="actionBar" :module="'招工'" :projectId="detailId" :imId="detailData.imId" :detailData="detailData"/>

    <van-dialog
      style="width:100%;border-radius:0;height:200px"
      theme="default"
      v-model="showvideoplay"
      :show-cancel-button="false"
      :show-confirm-button="false"
      closeOnClickOverlay
    >

      <div ref="videobox" id="mui-player"></div>
    </van-dialog>
    <div id="video-ios" style="height: 0"></div>

    <div class="recommend-title" v-if="projectList.length !== 0">相关工友推荐</div>
    <van-list
      class="list"
      v-model="incomeProjectListLoading"
      :finished="projectLoadFinished"
      @load="getProjectList"
    >
      <projectList :list="projectList" :dataId="dataId" ref="projectList"/>
    </van-list>

  </div>

</template>

<script>
import { workerDetail } from '@api/getJob'
import imagePopup from '@components/imagePopup/imagePopup'
import actionBar from '@/components/actionBar'
import { callByCoin, onceCallCoins } from '@api/integralMall'
import zhaohuo_icon_now from '../../assets/images/publicImg/zhaohuo_icon_now.png'
import { listRecommend } from '@api/distribution'
import projectList from '@/components/projectList'

import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
import { ImagePreview } from 'vant'

export default {
  name: 'distributionDetail',
  components: {
    imagePopup,
    actionBar,
    projectList
  },
  data () {
    return {
      zhaohuo_icon_now: zhaohuo_icon_now,
      token: '',
      isMyPub: '',
      show: false,
      isActive: '', // 选中公司的下标
      detailId: '',
      detailData: {},
      list: [],
      showImagePopup: false,
      imgUrl: '',
      showvideoplay: false,

      incomeProjectListLoading: false,
      projectLoadFinished: false,
      projectList: [],
      dataId: undefined
    }
  },
  created () {
    this.detailId = this.$route.query.id
    this.dataId = this.$route.query.id
    this.token = localStorage.getItem('token')
    this.getFindJobInit()
  },

  mounted () {
    // 支付回调
    this.$bridge.registerHandler('paySuccess', (data, responseCallback) => {
      this.payment()
    })
  },

  methods: {

    // 获取列表信息
    getProjectList () {
      this.pageNum++
      this.incomeListLoading = true
      var params = {
        pageNum: 0,
        pageSize: 10,
        id: this.detailId
      }
      listRecommend(params).then(res => {
        if (res.data.code === 200) {
          this.incomeProjectListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            // this.projectLoadFinished = true
          } else {
            this.projectList = this.list.concat(res.data.data.rows)
          }
          this.projectLoadFinished = true
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    getFindJobInit () {
      workerDetail({
        id: this.detailId
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
          this.content = res.data.data.content
          this.title = this.detailData.city + this.detailData.title
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    },
    // 下载附件
    attachsDetail (file, index) {

      if (file.fileType === 'mp4') {
        // 判断ios还是安卓
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {

          const video = document.getElementById('playVideos')
          if (video) {
            video.remove()
          }

          let str = document.createElement('video')
          str.id = 'playVideos'
          str.src = file.attachUrl
          str.setAttribute('type', 'video/mp4')
          str.setAttribute('controls', 'controls')
          str.style.width = '0'
          str.style.height = '0'
          str.play()
          document.getElementById('video-ios').append(str)
        } else {

          this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
            console.log('response:', response)
          })
          return

          this.showvideoplay = true

          setTimeout(function () {
            // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
            var mp = new MuiPlayer({
              container: '#mui-player',
              title: '视频',
              src: file.attachUrl,
              preload: 'auto',
              autoplay: true
            })
          }, 500)
        }
      } else {
        let list = []
        for (let i = 0; i < this.detailData.attachments.length; i++) {
          if (this.detailData.attachments[i].fileType !== 'mp4') {
            list.push(this.detailData.attachments[i].attachUrl)
          } else {
            if (i <= index) {
              index = index - 1
            }
          }
        }

        this.imagePreview = ImagePreview({
          images: list,
          showIndex: true,
          loop: false,
          startPosition: index
        })

      }
    },

    // 调用拨号功能
    callPhone () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (this.token) {
          onceCallCoins({
            dataType: 2,
            dataId: this.detailId
          }).then(res => {
            if (res.data.code === 200) {
              if (res.data.data.firstFlag === true) {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
                  console.log('response:', response)
                })

                this.$dialog.confirm({
                  title: '拨打电话',
                  message:
                    `拨打电话，需要支付${res.data.data.value}个邀工币。`,
                  confirmButtonColor: '#096CEFFF'
                })
                  .then(() => {
                    this.payment()
                  })
                  .catch(() => {
                    // on cancel
                  })
              } else {
                callByCoin({
                  dataType: 2, // 招工2，找活1
                  dataId: this.detailId
                }).then(res => {
                  if (res.data.code === 200) {
                    const phoneNumber = res.data.data.phone
                    const data = { phone: phoneNumber }
                    this.$bridge.callHandler('callPhone', data, response => {
                      console.log('response:', response)
                    })
                  }
                })
              }
            } else {
              this.$toastMsg(res.data.msg)
            }
          })
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },
    payment () {
      callByCoin({
        dataType: 2,
        dataId: this.detailId
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

#mui-player {
  height: 200px !important;
}

.recommend-title {
  @include add_size($font_size_16);
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 0px 0 8px;
}

.distributionDetail {
  padding-bottom: 70px;

  .info-div {

    .info-content {
      padding: 4px;
      display: flex;
      background-color: #F7F8FAFF;
      border-radius: 4px;
      margin-bottom: 8px;

      .icon-div {
        display: contents;

        .van-icon {
          margin-top: 2px;
          margin-right: 3px;
          font-size: 18px;
        }
      }
    }
  }

  .projectContent {
    border-radius: 5px;
    padding-top: 12px;

    .title {
      margin: 10px 0;
      width: 100%;
      line-height: 16px;
      border-left: 3px solid #096CEF;
      padding-left: 3px;
      @include add_size($font_size_17);

      //noinspection CssInvalidPseudoSelector
      ::v-deep .van-row {
        line-height: 16px;
      }

      .van-icon {
        @include add_size($font_size_20);
        vertical-align: -15%;
      }
    }

    .title1 {
      margin: 10px 0;
      width: 100%;
      line-height: 16px;
      @include add_size($font_size_17);

      .van-icon {
        font-size: 18px;
        vertical-align: -15%;
      }
    }

    .title2 {
      line-height: 16px;
      border-left: 3px solid #096CEF;
      padding-left: 3px;
      @include add_size($font_size_17);
    }

    .title3 {
      line-height: 16px;
      vertical-align: 15%;
    }

    .text {
      margin-bottom: 5px;
      @include add_size($font_size_16);
    }
  }

  .fileBox {
    display: flex;
    flex-wrap: wrap;

    img {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      flex-shrink: 0;
    }

    .videoBox {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
    }

    .icon_video_bg {
      width: 80px;
      height: 80px;
      position: absolute;
      top: -10px;
      left: 0;
      z-index: 0;
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .icon-attachDelete {
      position: absolute;
      top: -10px;
      right: -10px;
    }
  }
}

.distribution-top {
  padding: 0;
  @include add_size($font_size_20);
  margin-top: -80px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  text-align: center;

  .user-headImg {
    padding: 2px;
    background-color: #FFFFFF;
    border-radius: 5px;
    height: 70px;
    width: 70px;
    margin-top: -35px;
    display: inline;
  }

  .name {
    @include add_size($font_size_18);
  }

  .tag-div {
    padding: 7px 0;
  }

  .van-rate {
    vertical-align: -8%;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-rate__icon {
    display: none;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-rate__icon--full {
    display: block;
  }

  .phone-div {

    margin-top: 15px;
    border-radius: 0 0 5px 5px;
    background-color: #F2F7FFFF;
    padding: 10px;
    @include add_size($font_size_18);

    .phone {
      padding-top: 3px;
    }

    .van-icon {
      @include add_size($font_size_20);
      vertical-align: -15%;
    }
  }

  .btn_phone {
    width: 100px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}
.van-tag {
  background-color: #096CEF12;
  @include add_size($font_size_13);
  margin-right: 3px;
  padding: 3px 5px;
}
.bg {
  width: 100%;
  height: 130px;
  background: #096CEF;
}

.bgf {
  padding: 8px 12px 0;
  position: relative;
}

/*.WRAST {

  .text, .WRASText {
    @include add_size($font_size_15);
  }
;
}*/
</style>
